/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import toast from "react-hot-toast";
import { mimeTypeToExtension } from "./getFileMIME";

const checkIfValidFormat = (file: File, formats: string[]) => {
  if (formats && formats.length > 0) {
    let _formats = formats.map((f) => f.replace(".", ""));
    // "image/jpeg" => jpeg, "application/pdf" => pdf
    const fileExtension = mimeTypeToExtension(file.type);
    // ["image/*"]...etc
    const isFormatsHasAsterisk =
      formats.filter((f) => isFormatIncludesAllTypes(f, file.type)).length > 0;

    const isAllowed =
      _formats.includes(fileExtension!) ||
      _formats.includes(file.type) ||
      isFormatsHasAsterisk ||
      typeof file === "string"; //base64 string
    if (!isAllowed) {
      const allowedFormats = _formats.join(" / ");
      toast.error(`Only (${allowedFormats}) are allowed`);
      return false;
    }
    return true;
  }
};

export default checkIfValidFormat;

const isFormatIncludesAllTypes = (format: string, fileType?: string) => {
  const [type, asterisk] = format.split("/");
  if (!fileType) return false;
  return fileType.includes(type) && asterisk === "*";
};
